import {roleConstants} from "../constants/role.constants";

const initState = {
    roleList: null,
    roleElement: null
};

export function roleReducer(state = initState, action) {
    switch (action.type) {
        case roleConstants.ROLE_LIST_REQUEST:
        case roleConstants.ROLE_LIST_FAILURE:
        case roleConstants.ROLE_LIST_CLEAR:
            return {
                ...state,
                roleList: null,
            };
        case roleConstants.ROLE_LIST_SUCCESS:
            return {
                ...state,
                roleList: action.roleModel
            };
        case roleConstants.ROLE_BY_ID_SUCCESS:
            return  {
                ...state,
                roleElement: action.roleModel
            };
        case roleConstants.ROLE_BY_ID_FAILURE:
            return {
                ...state,
                roleElement: null
            };
        default:
            return state
    }
}
